import sipservice from '@/sip/sip_axios'

export function getSipSvrDate (baseurl, timestamp) {
  return sipservice({
    baseURL: baseurl,
    url: '/getccdate/getdate?callback=11',
    method: 'get',
    params: { _: timestamp }
  })
}
// http://sip.wecare-u.net/setevent/queueActionCJI?callback=jQuery1501537712243306406_1589783569179&type=1&usertype=agent&user=8002&orgidentity=8&list=2&pwdtype=plaintext&password=z2020&deviceexten=&pushevent=no&_=1589797832256

export function queueActionSip (baseurl, type, user, orgidentity, list, password, timestamp) {
  return sipservice({
    baseURL: baseurl,
    url: '/setevent/queueActionCJI?callback=11',
    method: 'get',
    params: {
      type: type, // 1签到2签出
      usertype: 'agent',
      user,
      orgidentity,
      list,
      pwdtype: 'plaintext',
      password,
      deviceexten: '',
      pushevent: 'no',
      _: timestamp
    }
  })
}

// http://sip.wecare-u.net/setevent/makeCallCJI?callback=jQuery1501537712243306406_1589783569180&targetdn=18112545657&targettype=exter&agentgroupid=2&usertype=agent&user=8002&orgidentity=8&pwdtype=plaintext&password=z2020&modeltype=Campaign&model_id=1&userdata=&callerid=&callername=&_=1589798812370

// eslint-disable-next-line camelcase
export function makeCallSip (baseurl, targetdn, agentgroupid, user, orgidentity, password, model_id, timestamp) {
  return sipservice({
    baseURL: baseurl,
    url: '/setevent/makeCallCJI?callback=11',
    method: 'get',
    params: {
      targetdn,
      targettype: 'exter',
      agentgroupid,
      usertype: 'agent',
      user,
      orgidentity,
      pwdtype: 'plaintext',
      password,
      modeltype: 'Campaign',
      model_id,
      userdata: '',
      callerid: '',
      callername: '',
      _: timestamp
    }
  })
}



// WEBPACK FOOTER //
// ./src/sip/sip_api.js